module.exports = __webpack_public_path__ + "static/media/howprotect.27b58fb8.png";